import {
	BlankState,
	LayoutBox,
} from '@bamboohr/fabric';
import { SectionStyledBox } from '../section-styled-box';
import { SectionStyledHeader } from '../section-styled-header';

export function WithholdingBlankState(props) {
	const { hasHeader = true, headerHeadlineSize, usesSectionComponent } = props;

	return <fieldset>
        <SectionStyledBox
            usesSectionComponent={ usesSectionComponent }
        >
            {hasHeader && (
                <SectionStyledHeader headlineSize={headerHeadlineSize}>
                    {$.__('Tax Withholding')}
                </SectionStyledHeader>
            )}
            <LayoutBox padding={ 4 }>
                <BlankState
                    icon="landmark-dome-regular"
                    level="widget"
                    subtitle={ $.__('Check to make sure your home and job location addresses are valid.') }
                    title={ $.__('Federal and State Tax withholding information will appear here when all of your data is in order.') }
                />
            </LayoutBox>
        </SectionStyledBox>
    </fieldset>
}
